import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod/v4';

export const Route = createFileRoute('/_auth/$env/clone')({
  validateSearch: zodValidator(
    z.object({
      syncLogId: z.string().optional(),
      trigger: z.boolean().optional(),
      page: z.coerce.number().optional(),
      pageSize: z.coerce.number().optional(),
    }),
  ),
  params: parseEnv(),
});
